import React from 'react';

import styled from '@emotion/styled';
import { mq, green02 } from '../../../_style';
import InnerLink from '../../atoms/about/innerLink';
import Br from '../../atoms/br';

const Container = styled.div`
  ${mq.pc} {
    padding-top: 90px;
  }
  ${mq.sp} {
    padding-top: 60px;
  }
`;
const Inner = styled.div`
  border: solid 1px ${green02};
  ${mq.pc} {
    display: flex;
    flex-wrap: wrap;
  }
  & > * {
    ${mq.pc} {
      width: 50%;
    }
  }
`
export default class InnerLinkGroup extends React.Component {
  render() {
    const path = String(this.props.path);
    const navItem = [
      {
        title: 'モンダミンの歴史',
        link: '/about/history',
        thumb: 'about/img-nav-01.jpg',
      },
      {
        title: '研究員のこだわり',
        link: '/about/flavor',
        thumb: 'about/img-nav-02.jpg',
      },
      {
        title: <>モンダミン工場<Br onlySp></Br>潜入レポート</>,
        link: '/about/factory',
        thumb: 'about/img-nav-03.jpg',
      },
      {
        title: '過去のレアアイテム',
        link: '/about/archive',
        thumb: 'about/img-nav-04.jpg',
      },
    ];

    return (
      <Container>
        <Inner>
          {navItem.map((item, i) => (
            <InnerLink key={i} isCurrent={path.replace(/\//g, '') === item.link.replace(/\//g, '') ? 'is-current' : ''} thumb={item.thumb} to={item.link}>{item.title}</InnerLink>
          ))}
        </Inner>
      </Container>
    );
  }
}
